import styled from 'styled-components';

import RTECompose from 'contentful/RTE_compose';

import { grey5, cefRed } from 'constants/variables';

const GreyBox = ({ content: { content }, id }) => (
  <div
    className="evergreen__container evergreen__container-large"
    id={`guide-summary_${id}`}>
    <GreyBoxWrapper className="fl jc-c ai-c evergreen__grey-section">
      <div className="evergreen__grey-section--content">
        <h2 className="fs-34 m-fs-48 ff-body">Guide Summary</h2>
        <RTECompose content={content} fieldType="content" />
      </div>
    </GreyBoxWrapper>
  </div>
);

const GreyBoxWrapper = styled.div`
  background-color: ${grey5};
  border-left: 4px solid ${cefRed};

  p {
    font-size: 1.125rem;
    line-height: 1.5;
  }
`;

export default GreyBox;
